import type { VasAncillary } from '@/src/types/itinerary'
import { useMemo } from 'react'

/**
 * Hook for calculating insurance pricing and configuration
 * Processes selected insurances and creates pricing configuration
 */
const useInsurancePricing = (selectedInsurances: VasAncillary[] = []) => {
    const {
        priceConfig: insurancePricingConfig,
        totalInsurancePrice,
        totalInsurancePriceWithVat
    } = useMemo(() => {
        const priceConfig: Record<string, { price: number; isDiscount: boolean }> = {}
        let totalInsurancePrice = 0
        let totalInsurancePriceWithVat = 0

        if (Array.isArray(selectedInsurances) && selectedInsurances.length > 0) {
            selectedInsurances.forEach((insurance: VasAncillary, index: number) => {
                const {
                    title = `Insurance ${index + 1}`,
                    totalPremiumAmount = 0,
                    vatAmount = 0
                } = insurance?.vasDetails?.[0] || {}
                totalInsurancePrice += totalPremiumAmount || 0
                totalInsurancePriceWithVat += totalPremiumAmount + vatAmount
                priceConfig[title] = {
                    price: totalPremiumAmount || 0,
                    isDiscount: false
                }
            })
        }

        return { priceConfig, totalInsurancePrice, totalInsurancePriceWithVat }
    }, [selectedInsurances])

    return {
        insurancePricingConfig,
        totalInsurancePrice,
        totalInsurancePriceWithVat
    }
}

export default useInsurancePricing
